module.exports = __webpack_public_path__ + "glasses.svg?abfff31aaa927fd6346ce363830c2fa6";